export default "__VITE_PUBLIC_ASSET__bf7f64fd__"